// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api: 'http://localhost:5050',
  emailApi: 'https://localhost:5050',
  uploadApi: 'https://localhost:5050',
  authURi: 'https://auth.afrogiftcard.com.ng',
  appName: 'Auth',
  domain: '@auth.searchforcleaner.com',
  teegramToken:'',
  appDomain: 'https://localhost:5050',
  pub_key: "7f2G4iAwNUrJcGe05gNUrJBYZjsGkcAY0LWp9ck0826oA0826wNUrJcAf2G2G4iAnrY0LWp9n",
  authApi: "926722deb7da24c5588f02b94f5ca98af0cd0ecaef32957370500c690ac88f71",
  paystack: "pk_test_f928b8d96c6df3d8e0c38ad074218da324a4a996",
  tawkexternal: "https://tawk.to/chat/68b0244fbe8646192a41984e/1j3o0rllg",
  marketplace: "https://marketplace.afrogiftcard.com.ng",
  wallet: "0xC9a7026e65cf937DB824f031aF6Ed030263B130c",
  infurakey: "fe1059019f144f25a9e2e7c72d06232f"
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
